var currentSelection = {
    department : [],
    class : []
};

jQuery(document).ready(function($) {

    $('.filter').click(function(){
        var filterType = $(this).data('filter-type');
        var value = $(this).data('filter');
        $('#showMore').attr('data-page', 1);

        if($(this).hasClass('-active')){
            $(this).removeClass('-active');
            removeFromArray(currentSelection[filterType], value);
        } else {
            $(this).addClass('-active');
            currentSelection[filterType].push($(this).data('filter'));
        }
        filterCards();
        if($('.material-preview.-hidden.-selected').length > 7  ){
            $('#showMore').show();
        }
        changePreviewsHeadingText();

    });

    jQuery('#showMore').click(function(){
       filterCards(true);
    });

    function filterCards(more) {
        var ajaxUrl = jQuery('[data-ajax-url]').data('ajax-url');
        var page = parseInt(jQuery('#showMore').attr('data-page'));
        var data = {action : 'filterMaterial', 'page' : page, selection: currentSelection};

        jQuery.ajax({
            url: ajaxUrl,
            type: 'GET',
            data: data,
            success: function(response){
                $('#showMore').attr('data-page', response.data.page);
                if(more){
                    $('.preview-wrapper').append(response.data.html);
                } else {
                    $('.preview-wrapper').html(response.data.html);

                }
                if(response.data.page > response.data.maxPages){
                    $('#showMore').hide();
                    return;
                }
                $('#showMore').show();
            }
        });
    }

    function removeFromArray(arr, val) {
        var index = arr.indexOf(val);

        if (index > -1) {
            arr.splice(index, 1);
        }
        return arr;
    }


    function changePreviewsHeadingText() {
        var previewHeading = jQuery('#previews-heading');
        var selectedFilters = document.querySelectorAll('.filter.-active');
        var defaultText = previewHeading.data('default-text');
        var selectedText = previewHeading.data('selected-text');

        if(selectedFilters.length > 0){
            previewHeading.text(selectedText);
            return;
        }

        previewHeading.text(defaultText);
    }
});